// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1VNcnof-TtYirs20ocH6ps","link":"SixT1KVRTT_7Pu994A1Xh b-overlay"};